var React = require('react');
var Link = require('react-router').Link;
var events = require('./day-events');
var encodeSlug = require('./room-slug');
var dayMatch = require('./day-match');

var SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var CHIP_ORDER = [1, 2, 3, 4, 5, 6, 0];
var PREVIEW = 18;

function startSortKey(start) {
  var s = String(start || '').trim().toLowerCase();
  var m = s.match(/^(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?/);
  if (!m) return 9999;
  var h = parseInt(m[1], 10);
  var min = m[2] ? parseInt(m[2], 10) : 0;
  var ap = m[3] || '';
  if (ap.indexOf('p') === 0 && h < 12) h += 12;
  if (ap.indexOf('a') === 0 && h === 12) h = 0;
  return h * 60 + min;
}

var DayBrowser = React.createClass({
  getInitialState: function () {
    return { mode: 'tonight', weekday: new Date().getDay(), expanded: false };
  },

  referenceDate: function () {
    if (this.state.mode === 'tonight') return new Date();
    return dayMatch.dateForWeekday(this.state.weekday, new Date());
  },

  setTonight: function () {
    this.setState({ mode: 'tonight', weekday: new Date().getDay(), expanded: false });
  },

  setWeekday: function (index) {
    this.setState({ mode: 'weekday', weekday: index, expanded: false });
  },

  render: function () {
    var self = this;
    var ref = this.referenceDate();
    var dayName = dayMatch.WEEKDAYS[ref.getDay()];
    var matched = (events || []).filter(function (ev) {
      return dayMatch.eventRunsOn(ev.day, ref);
    });
    matched.sort(function (a, b) {
      var c = a.casino.localeCompare(b.casino);
      if (c) return c;
      return startSortKey(a.start) - startSortKey(b.start);
    });

    var visible = this.state.expanded ? matched : matched.slice(0, PREVIEW);
    var groups = [];
    var byCasino = {};
    visible.forEach(function (ev) {
      if (!byCasino[ev.casino]) {
        byCasino[ev.casino] = { casino: ev.casino, state: ev.state || '', events: [] };
        groups.push(byCasino[ev.casino]);
      }
      byCasino[ev.casino].events.push(ev);
    });

    var dateLabel = ref.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    var heading = this.state.mode === 'tonight'
      ? 'On file tonight'
      : 'On file ' + dayName;

    var chips = CHIP_ORDER.map(function (index) {
      var on = self.state.mode === 'weekday' && self.state.weekday === index;
      return (
        <button
          type="button"
          key={SHORT[index]}
          className={on ? 'filter-chip is-on' : 'filter-chip'}
          aria-pressed={on}
          onClick={function () { self.setWeekday(index); }}
        >{SHORT[index]}</button>
      );
    });

    var rows = groups.map(function (group) {
      var lines = group.events.map(function (ev, i) {
        var bits = [ev.name, ev.start, ev.buyin].filter(Boolean);
        var extra = dayMatch.isPlainWeekdayLabel(ev.day) ? '' : ev.day;
        return (
          <li className="home-day-event" key={group.casino + '-' + i}>
            {bits.join(' · ')}
            {extra ? <span className="home-day-source"> · {extra}</span> : null}
          </li>
        );
      });
      return (
        <li className="home-day-room" key={group.casino}>
          <Link to={'/allcasinos/' + encodeSlug(group.casino)}>{group.casino}</Link>
          {group.state ? <span className="home-day-state">{group.state}</span> : null}
          <ul>{lines}</ul>
        </li>
      );
    });

    return (
      <section className="home-day" aria-label="Tournaments on file by day">
        <h2 className="home-day-title">{heading}</h2>
        <p className="home-day-note">
          {dayName}, {dateLabel}. Lines come from schedules already on file. A first, third, or last-of-month event is included only on that date. Alternating weeks are left off because the file does not say which weeks.
        </p>
        <div className="tourney-filters" role="group" aria-label="Pick a day">
          <div className="filter-row">
            <button
              type="button"
              className={this.state.mode === 'tonight' ? 'filter-chip is-on' : 'filter-chip'}
              aria-pressed={this.state.mode === 'tonight'}
              onClick={this.setTonight}
            >Tonight</button>
            {chips}
          </div>
        </div>
        <p className="home-day-count">
          {matched.length === 1 ? '1 event on file' : matched.length + ' events on file'}
        </p>
        {matched.length ? (
          <ul className="home-day-list">{rows}</ul>
        ) : (
          <p className="tourney-empty">Nothing on file matches that day.</p>
        )}
        {matched.length > PREVIEW ? (
          <button
            type="button"
            className="filter-chip home-day-more"
            onClick={function () { self.setState({ expanded: !self.state.expanded }); }}
          >{this.state.expanded ? 'Show fewer' : 'Show all ' + matched.length}</button>
        ) : null}
      </section>
    );
  }
});

module.exports = DayBrowser;



// WEBPACK FOOTER //
// ./js/day-browser.jsx